import React from 'react'
import _ from 'lodash'
import { VictoryArea, VictoryLine, VictoryGroup, VictoryChart, VictoryTheme, VictoryLabel, VictoryTooltip, VictoryAxis } from 'victory';

function getUpdateDate(timeStampDate) {
  const date = new Date(parseInt(timeStampDate))
  return `${date.getUTCFullYear().toString().slice(-2)}/${date.getMonth() + 1}/${date.getDate()}\n ${date.getHours()}:${date.getMinutes()}`
 }

const grapht = (props) => {
  var data = []
  var data2 = []
  var media = []
  var media2 = []
  var domain = props.domain
  var mediad = props.media ? props.media : 190
  var mediad2 = props.media2 ? props.media2 : 80
   if(_.isEmpty(props)) {
     data = [{Control: 'C 0', pa:0}, {Control: 'C 1', pa: 0}]
     data2 = [{Control: 'C 0', pa:0}, {Control: 'C 1', pa: 0}]
     media = [{month: "C 0", media: 120},{month: "C 1", media: 120},{month: "C 2", media: 120},{month: "C 3", media: 120},{month: "C 4", media: 120}]
     media2 = [{month: "C 0", media: 80},{month: "C 1", media: 80},{month: "C 2", media: 80},{month: "C 3", media: 80},{month: "C 4", media: 80}]
   } else {
     if(props.data){
       data = []
       var arr = _.orderBy(props.data, ['timestamp'], ['asc']);

       arr.map((e,i) => {
         data.push({Control: getUpdateDate(e.timestamp), pa: e[props.index]})
         data2.push({Control: getUpdateDate(e.timestamp), pa:e[props.index2]})

         media.push({month: getUpdateDate(e.timestamp), media: mediad})
         media2.push({month: getUpdateDate(e.timestamp), media: mediad2})

       })
     }
   }

  return (
        <VictoryChart domainPadding={2}
        style={{
          axis: {stroke: "rgba(250,250,250,0.4)"},
          axisLabel: {fontSize: 12,fill: 'white', stroke: 'white'}
        }}
        >

          <VictoryLine
          labelComponent={<VictoryTooltip/>}
          eventKey={(datum) => datum.Control}
          style={{
            data: {stroke: "rgba(255,255,255,0.8)"},
            labels: {fontSize: 12,fill: 'white'}
          }}
          data={data}
          x="Control"
          y={(datum) => datum.pa}
        />
          <VictoryLine
          labelComponent={<VictoryTooltip/>}
          eventKey={(datum) => datum.Control}
          style={{
            data: {stroke: "rgba(255,255,255,0.8)"},
            labels: {fontSize: 12,fill: 'white'}
          }}
          data={data2}
          x="Control"
          y={(datum) => datum.pa}
        />
        <VictoryLine
        data={media}
        style={{
          data: {stroke: "rgba(255, 209, 18, 0.6)", 'stroke-dasharray': [5, 5]},
          labels: {fontSize: 12, fill: 'yellow'},
          parent: {border: "1px dotted yellow"}
        }}
        x="month"
        y={(datum) => datum.media}
        />
        <VictoryLine
        data={media2}
        style={{
          data: {stroke: "yellow", 'stroke-dasharray': [5, 5]},
          labels: {fontSize: 12, fill: 'white'},
          parent: {border: "1px dotted white"}
        }}
        x="month"
        y={(datum) => datum.media}
        />
        <VictoryAxis dependentAxis
        domain= {domain}
        style={{
          axis: {stroke: "rgba(250,250,250,1)"},
          axisLabel: {fontSize: 12, fill: 'white'},
          ticks: {stroke: 'white'},
          tickLabels: {
            fill: 'white'
          }
        }}

        />
        <VictoryAxis
        style={{
          axis: {stroke: "rgba(250,250,250,1)"},
          axisLabel: {fontSize: 12, fill: 'white'},
          ticks: {stroke: 'white'},
          tickLabels: {
            fill: 'white'
          }
        }}

        />
      </VictoryChart>
  )
}
export default (props) => {
  return <g>{grapht(props)}</g>
}



// WEBPACK FOOTER //
// ./src/components/ViewStatics/ViewStaticsDouble.js